import React from "react";
import { Box, Button } from "@mui/material";

const PlatformTabs = ({ tabs, activeTab, onTabChange }) => {
  return (
    <Box
      sx={{
        position: "relative",
        width: { xs: "100vw", lg: "100%" },
        marginLeft: { xs: "calc(-50vw + 50%)", lg: "0" },
        marginRight: { xs: "calc(-50vw + 50%)", lg: "0" },
        marginTop: { xs: "20px", lg: "0px" },
        "&::after": {
          content: '""',
          position: "absolute",
          right: 0,
          top: 0,
          height: "100%",
          width: "40px",
        //   background: "linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%)",
          pointerEvents: "none",
          display: "block",
        }
      }}
    >
      <Box
        sx={{
          display: "flex",
          gap: "12px",
          backgroundColor: "transparent",
          alignItems: "center",
          overflowX: "auto",
          scrollbarWidth: "none",
          "&::-webkit-scrollbar": {
            display: "none",
          },
          "-ms-overflow-style": "none",
          "&::after": {
            content: '""',
            minWidth: "1px",
            height: "1px",
          },
          "& > :first-of-type": {
            marginLeft: { xs: "20px", lg: "0" }  // Only add margin on mobile
          }
        }}
      >
        {tabs.map((tab) => (
          <Box 
            key={tab.label} 
            sx={{ 
              display: "flex", 
              alignItems: "center",
              flexShrink: 0
            }}
          >
            <Button
              onClick={() => onTabChange(tab.label)}
              sx={{
                borderRadius: "100px",
                fontSize: "14px",
                fontWeight: 500,
                textTransform: "none",
                color: "#000",
                backgroundColor: activeTab === tab.label ? "#FFFFFF" : "#fff",
                border: activeTab === tab.label 
                  ? "2px solid var(--brand-color)" 
                  : "1px solid #E8E8E8",
                "&:hover": {
                  backgroundColor: activeTab === tab.label 
                    ? "#FFFFFF"
                    : "#FFFFFF",
                },
                whiteSpace: "nowrap",
                padding: "10px 24px",
                minWidth: "unset",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              {tab.icon && (
                <Box component="span" sx={{ display: "flex", alignItems: "center", fontSize: "20px" }}>
                  {tab.icon}
                </Box>
              )}
              {tab.label}
            </Button>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default PlatformTabs; 